module.exports = __webpack_public_path__ + "static/media/cash_white.f6d52deb.svg";